<template lang="html">
  <section class="settings-element">
    <div class="m-settings_section">
      <svg v-if="allowEdit" @click.stop="onSettingsEdit">
        <use :xlink:href="getUtilityIcon('settings')"></use>
      </svg>
      <svg class="delete" @click.stop="onSettingsDelete">
        <use :xlink:href="getUtilityIcon('delete')"></use>
      </svg>
    </div>
  </section>
</template>

<script lang="js">
  import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";

  export default  {
    name: "settings-element",
    props: {
      allowEdit: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      getUtilityIcon(iconName) {
        return iconsUri.getUtilityUrl(iconName);
      },
      onSettingsEdit() {
        this.$emit("on-settings-edit-click", {});
      },
      onSettingsDelete() {
        this.$emit("on-settings-delete-click", {});
      }
    }
  }
</script>

<style scoped lang="scss">
  .settings-element {
    box-sizing: border-box;
    min-width: 2.4rem;
    position: relative;
    .m-settings_section {
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;
      svg {
        width: 1rem;
        height: 1rem;
        cursor: pointer;
        margin-left: 0.3rem;
        vertical-align: baseline;
      }
      .delete {
        fill: #c23934;
      }
    }
  }
</style>
